import auth from './auth'

export default {
  mixins: [auth],
  data: function () {
    return {
      libs: { auth }
    }
  },
  computed: {
    token: function () {
      return this.$route.query.token
    }
  },
  methods: {
    limitedLogin: function () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('limitedLogin', this.token).then((response) => {
          if (this.hasCurrentUser) {
            // if we have a current user, keep them logged in if the token matches
            // otherwise log them out, and use the user from the token
            if (this.currentUser.uuid !== response.user.uuid) {
              this.libs.auth.logout()
            }
          }
          this.libs.auth.storeTokens({ accessToken: response.token, limited: true })
          resolve(response.user)
        }, (messages) => {
          reject(messages)
        })
      })
    }
  }
}
